import { Satisfaction } from 'lib-shared-legacy-types';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { RootReducerStateT } from 'app/reducers/rootReducer';
import { LanguageCustomizationForm } from 'components/settings/components/sections/satisfaction/components/DixaMessengerCSAT/CustomizationPage/types';
import { withRouter } from 'hocs/router';

import { notificationActions } from '../../../../notifications/actions/notification';
import satisfactionActions from '../../../actions/satisfaction';
import {
  CustomizationPageRoute,
  CustomizationPageRouteOwnProps,
} from '../../../components/sections/satisfaction/components/DixaMessengerCSAT/CustomizationPage/CustomizationPageRoute';

const mapDispatchToProps = (
  dispatch: Dispatch,
  ownProps: CustomizationPageRouteOwnProps,
) => {
  function redirectAfterSettingCreation({
    data: { id },
  }: Satisfaction.DixaMessengerCsatSettingsPostResponse) {
    if (ownProps.mode === 'create') {
      dispatch(
        notificationActions.notificationAdd({
          title: 'Settings successfully created for this language',
          className: 'success',
          icon: 'i-done',
          time: 5000,
        }),
      );

      ownProps.navigate(
        `/settings/satisfaction/messenger/${ownProps.params.language}/edit/${id}`,
      );
    }

    if (ownProps.mode === 'edit') {
      dispatch(
        notificationActions.notificationAdd({
          title: 'Settings successfully updated for this language',
          className: 'success',
          icon: 'i-done',
          time: 5000,
        }),
      );
    }
  }

  return {
    loadDixaMessengerSettingsAllLevels() {
      dispatch(
        satisfactionActions.satisfactionLoadDixaMessengerAllLevelsSettingsRequest(),
      );
    },

    onSubmit(customization: LanguageCustomizationForm.FormValues) {
      const payload: Partial<Satisfaction.DixaMessengerCsatSettings> = {
        id: ownProps.params.settingsId,
        customization: customization,
        channel: 'messenger',
        level: 'language',
        language: ownProps.params.language,
      };

      return new Promise<Satisfaction.DixaMessengerCsatSettingsPostResponse>(
        (resolve, reject) => {
          dispatch(
            satisfactionActions.satisfactionSaveDixaMessengerLanguageLevelSettingsRequest(
              payload,
              { resolve, reject },
            ),
          );
        },
      ).then(redirectAfterSettingCreation);
    },
  };
};

export type CustomizationPageRouteDispatchProps = ReturnType<
  typeof mapDispatchToProps
>;

export const DixaMessengerCustomizationPageRoute = withRouter(
  connect<
    void,
    CustomizationPageRouteDispatchProps,
    CustomizationPageRouteOwnProps,
    RootReducerStateT
  >(
    undefined,
    mapDispatchToProps,
  )(CustomizationPageRoute),
);
